import React from 'react';
import Stack from '@mui/material/Stack';
import ClientStatistics from './ClientStatistics';
import DocumentationStatistics from './documentation/DocumentationStatistics';

import type { Statistic as StatisticType } from '../../common/types/statistics/fbStatistics';

type Props = {
  statistic: StatisticType | null | undefined;
};

function Statistic({ statistic }: Props) {
  if (statistic == null) return null;

  return (
    <Stack spacing={4}>
      <ClientStatistics statistics={statistic.clientStatistics} />
      <DocumentationStatistics statistics={statistic.documentationStatistics} />
    </Stack>
  );
}

export default Statistic;
